import api from "./client";
import type { Style } from "@/types/api";

export const getStyles = (): Promise<Style[]> =>
  api.get("/v1/styles").then((res) => res.data.data);
